<script>
    import GameAddHeader from '@/components/page-provider-and-game-edit/game-add/GameAddHeader.vue';
    import GameAddData from '@/components/page-provider-and-game-edit/game-add/GameAddData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_PAG_GAME_ADD}
        },
        components: {
            GameAddHeader: GameAddHeader,
            GameAddData: GameAddData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <GameAddHeader />
        <hr class="hr_light_98">
        <GameAddData />
    </div>
</template>